import {addNotification_UNSAFE} from '@logistics-frontend/blocks/notifications/context'
import {Translator} from '@logistics-frontend/core/i18n'
import {call, getContext} from 'typed-redux-saga'

import {inheritDescriptor} from './inheritDescriptor'

const defaultCatcher = function* () {
  const t = yield* getContext<Translator>('i18n')
  addNotification_UNSAFE(t('request.mutation.error', 'Ошибка'), {
    type: 'error',
  })
}

export const catchWith =
  <T extends any[] = []>(catcher: (e: Error, ...rest: T) => any = defaultCatcher, propagate = false) =>
  <F extends (...any: any[]) => any>(
    _target: any,
    _key: string,
    descriptor: TypedPropertyDescriptor<F>,
  ): ((...args: T) => any) extends F ? TypedPropertyDescriptor<F> : '' => {
    const func = descriptor.value

    if (!func) {
      throw new Error('No descriptor value')
    }

    return inheritDescriptor(descriptor, function* (...args: any) {
      try {
        return yield* call([this, func], ...args)
      } catch (error) {
        yield* call(catcher as any, error, ...args)

        if (propagate) {
          throw error
        }
      }
    }) as any
  }
